(() => {
  const carouselSelector = '.jdgm-widget.jdgm-cards-carousel';

  const createElement = (tag, className, text) => {
    const element = document.createElement(tag);
    element.className = className;

    if (text) {
      element.textContent = text;
    }

    return element;
  };

  const getRating = (header) => {
    const stars = header.querySelector('.jdgm-average-rating .jdgm-stars');
    const ratingText = header.querySelector('.jdgm-rating-text');
    const accessibleRating = stars?.getAttribute('aria-label') || '';
    const score = accessibleRating.match(/[0-9]+(?:\.[0-9]+)?/)?.[0]
      || ratingText?.textContent.match(/[0-9]+(?:\.[0-9]+)?/)?.[0]
      || '';
    const rawCount = header.querySelector('.jdgm-reviews-count')?.textContent.trim() || '';
    const digits = rawCount.replace(/\D/g, '');
    const count = digits ? Number(digits).toLocaleString('en-GB') : rawCount;

    return { count, score, stars };
  };

  const buildRatingPanel = (header) => {
    const headerInfo = header.querySelector('.jdgm-header-info');
    const averageRating = header.querySelector('.jdgm-average-rating');

    if (!headerInfo || !averageRating || averageRating.querySelector('.dyefor-reviews__score')) {
      return getRating(header);
    }

    const rating = getRating(header);
    const label = createElement('p', 'dyefor-reviews__panel-label', 'Customer rating');
    const score = createElement('strong', 'dyefor-reviews__score', rating.score);
    const meta = createElement('div', 'dyefor-reviews__rating-meta');
    const count = createElement(
      'span',
      'dyefor-reviews__rating-count',
      rating.count ? `${rating.count} customer reviews` : 'Customer reviews'
    );

    if (rating.stars) {
      meta.append(rating.stars);
    }

    meta.append(count);
    averageRating.replaceChildren(score, meta);
    headerInfo.prepend(label);

    return rating;
  };

  const populateCustomerAvatars = (root) => {
    const avatars = root.querySelector('.dyefor-reviews__avatars');

    if (!avatars || avatars.childElementCount) {
      return;
    }

    const sources = [];

    root.querySelectorAll('.jdgm-card:not([data-clone-type]) > img').forEach((image) => {
      const source = image.currentSrc || image.src;

      if (sources.length < 3 && source && !sources.includes(source)) {
        sources.push(source);
      }
    });

    sources.forEach((source) => {
      const image = document.createElement('img');
      image.src = source;
      image.alt = '';
      image.loading = 'lazy';
      image.width = 42;
      image.height = 42;
      avatars.append(image);
    });
  };

  const buildCustomerAvatars = () => {
    const wrap = createElement('div', 'dyefor-reviews__customers');
    const avatars = createElement('span', 'dyefor-reviews__avatars');

    wrap.append(avatars);
    wrap.append(createElement('strong', 'dyefor-reviews__customers-label', 'Personalised, delivered and reviewed'));
    return wrap;
  };

  const buildStoryPanel = (root) => {
    const story = createElement('div', 'dyefor-reviews__story');
    story.append(createElement('p', 'dyefor-reviews__story-label', 'Verified customer reviews'));
    story.append(createElement('h3', 'dyefor-reviews__story-title', 'See the finished result through their eyes.'));
    story.append(createElement(
      'p',
      'dyefor-reviews__story-text',
      'Real photos and feedback from Dyefor customers, shared after their orders arrived.'
    ));
    story.append(buildCustomerAvatars());
    return story;
  };

  const buildGalleryHeading = (rating) => {
    const heading = createElement('div', 'dyefor-reviews__gallery-heading');
    heading.append(createElement('h3', 'dyefor-reviews__gallery-title', 'Customer photos & stories'));
    heading.append(createElement(
      'span',
      'dyefor-reviews__gallery-count',
      rating.count ? `${rating.count} reviews` : 'Customer reviews'
    ));
    return heading;
  };

  const enhanceCarousel = (root) => {
    if (root.dataset.dyeforReviewsEnhanced === 'true') {
      populateCustomerAvatars(root);
      return;
    }

    const header = root.querySelector('.jdgm-header');
    const title = header?.querySelector('.jdgm-title');
    const content = root.querySelector('.jdgm-content');

    if (!header || !title || !content) {
      return;
    }

    root.dataset.dyeforReviewsEnhanced = 'true';
    root.closest('.shopify-section')?.classList.add('dyefor-reviews-section');

    const titleId = `DyeforReviews-${root.dataset.jdgmBlockId || Math.random().toString(36).slice(2)}`;
    title.id = titleId;
    title.textContent = 'Made personal. Rated honestly.';
    root.setAttribute('role', 'region');
    root.setAttribute('aria-labelledby', titleId);

    header.prepend(createElement('p', 'dyefor-reviews__eyebrow', 'Real Dyefor orders'));
    const rating = buildRatingPanel(header);
    header.append(buildStoryPanel(root));
    content.before(buildGalleryHeading(rating));
    populateCustomerAvatars(root);
  };

  const enhanceCarousels = () => {
    document.querySelectorAll(carouselSelector).forEach(enhanceCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceCarousels, { once: true });
  } else {
    enhanceCarousels();
  }

  const observer = new MutationObserver(enhanceCarousels);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', enhanceCarousels);
})();
